var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.649,
    height: 151.216,
    viewBox: "0 0 102.649 151.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19135",
    "data-name": "Path 19135",
    d: "M345.082,297.952l1.067-.534-.712-.889a54.426,54.426,0,0,0-34.513-21.882V254.9h-21.17v19.569a57.074,57.074,0,0,0,0,112.078v19.569h21.17V386.369a51.116,51.116,0,0,0,12.453-4.092l1.067-.534-.712-.89a52.928,52.928,0,0,1-8.361-18.5l-.356-1.067-1.067.534a32.39,32.39,0,0,1-13.343,3.024c-18.858,0-33.268-14.766-33.268-34.513,0-19.569,14.41-34.157,33.445-34.157,10.674,0,19.569,4.625,25.974,13.343l.712.89.712-.89A50.222,50.222,0,0,1,345.082,297.952Z",
    transform: "translate(-243.5 -254.9)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.08c966cb04d383e406c343c5b52fc2e9.svg";
export { ForwardRef as ReactComponent };